/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfBoolean } from '../models/platform-api-result-of-boolean';
import { postPublicContact } from '../fn/public/post-public-contact';
import { PostPublicContact$Params } from '../fn/public/post-public-contact';
import { postPublicSubscribe } from '../fn/public/post-public-subscribe';
import { PostPublicSubscribe$Params } from '../fn/public/post-public-subscribe';


/**
 * Anonieme endpoints van de landingspagina (mechanicsinmotion.be). Geen JWT: Caddy laat op
 * het landingsdomein alleen /api/public/* door naar de API. Beide antwoorden altijd 200 bij
 * een gevuld honeypot-veld (bot) zonder iets te doen; misbruik wordt begrensd met
 * PublicLandingPolicy (per IP).
 */
@Injectable({ providedIn: 'root' })
export class PlatformPublicService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postPublicSubscribe()` */
  static readonly PostPublicSubscribePath = '/api/public/subscribe';

  /**
   * Betalijst: contact aanmaken in Brevo met double opt-in.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postPublicSubscribe()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postPublicSubscribe$Response(params: PostPublicSubscribe$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postPublicSubscribe(this.http, this.rootUrl, params, context);
  }

  /**
   * Betalijst: contact aanmaken in Brevo met double opt-in.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postPublicSubscribe$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postPublicSubscribe(params: PostPublicSubscribe$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postPublicSubscribe$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postPublicContact()` */
  static readonly PostPublicContactPath = '/api/public/contact';

  /**
   * Contactformulier: mail naar het ontvangstadres, met de afzender als Reply-To.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postPublicContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postPublicContact$Response(params: PostPublicContact$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postPublicContact(this.http, this.rootUrl, params, context);
  }

  /**
   * Contactformulier: mail naar het ontvangstadres, met de afzender als Reply-To.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postPublicContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postPublicContact(params: PostPublicContact$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postPublicContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

}
